var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionCard',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Processes ")]},proxy:true},{key:"body",fn:function(){return [_c('DataTable',{attrs:{"sort-by":"name","item-per-page":10,"selected":_vm.selected,"headers":_vm.tableHeaders,"items":_vm.items,"disable-sort":false,"multi-select":""},on:{"click:row":function($event){return _vm.$emit('click:row', $event)},"current-items":function($event){return _vm.$emit('current-items', $event)}},scopedSlots:_vm._u([{key:"item.legend",fn:function(ref){
var item = ref.item;
return [_c('div',{style:({
						width: '40px',
						height: '15px',
						background: item.processColor
					})})]}}])})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }